export default function extractAddressComponent(property: string, addressString: string) {
  return new RegExp(`<span class="${property}">(.*?)</span>`).exec(addressString)?.[1]
}
